
import  VideoSegmentAnnotator from './VideoSegmentAnnotator';
export * from './types';
export default VideoSegmentAnnotator;